module.exports = __webpack_public_path__ + "static/cheever-hex-cdcbc84ed7455148c24d8bbce8b8381b.png";